// extracted by mini-css-extract-plugin
export var card = "_l9-1";
export var summary = "_l9-0";